// import './polyfill';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/ie11'; // For IE 11 support
import { isMobileOnly } from 'react-device-detect';
import Mobile from './Mobile.js';
// React imports
import React from 'react';
import ReactDOM from 'react-dom';
import {
    HashRouter,
    Route,
    Switch,
    Redirect,
    BrowserRouter,
} from 'react-router-dom';
import PropTypes from 'prop-types';

// Redux imports
import store from './redux/store';
import { Provider } from 'react-redux';

// Redux setup
import { createBrowserHistory } from 'history';
import { syncHistoryWithStore } from 'react-router-redux';
var browserHistory = createBrowserHistory();
const history = syncHistoryWithStore(browserHistory, store);

// Notifications import
import { ToastContainer } from 'react-toastify';

// Other setup
import CacheBuster from './components/CacheBuster/index';
import 'react-dates/initialize';
import './scss/style.scss';

// Components
import FullScreenLoader from './components/FullScreenLoader';
const loading = () => <FullScreenLoader />;
const MainLayout = React.lazy(() => import('./containers/Layout'));
const Registration = React.lazy(() => import('./scenes/Registration/index'));
const SignupConfirmation = React.lazy(() =>
    import('./scenes/SignupConfirmation/index')
);
const Login = React.lazy(() => import('./scenes/Login/index'));
const confirmationPage = React.lazy(() => import('./scenes/confirmationPage'));
const forgotPasswordPage = React.lazy(() =>
    import('./scenes/forgotPasswordPage')
);
const resetPasswordPage = React.lazy(() =>
    import('./scenes/resetPasswordPage')
);
const UnlockAccountPage = React.lazy(() =>
    import('./scenes/UnlockAccountPage/index.js')
);
// import UnlockAccountPage from './scenes/UnlockAccount/UnlockAccountPage.jsx';

const Chat = React.lazy(() => import('./scenes/Chat'));
const PDF = React.lazy(() => import('./scenes/ServicesReport/PDFPage'));
const PDFHealthCheckReport = React.lazy(() =>
    import('./scenes/HealthCheckReport/PDFPage')
);
const PDFCCPAReport = React.lazy(() => import('./scenes/CCPAReport/PDFPage'));
const Packages = React.lazy(() => import('./scenes/Packages'));

// Google tag management
import TagManager from 'react-gtm-module';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
const tagManagerArgs = {
    gtmId: 'GTM-P5KV4T9',
};
TagManager.initialize(tagManagerArgs);

// import ReactGA from 'react-ga';
// var googleUid = 'UA-127644154-7';
// let pagePath =
//     window.location.hash != ''
//         ? window.location.hash
//         : window.location.pathname + window.location.search;
// ReactGA.initialize(googleUid, { debug: true });
// ReactGA.pageview(pagePath); //for initial state

// Function to check if user is logged in
const loggedIn = () => {
    const boolToken = store.getState().tokenReducer.tokens.loginToken;
    // console.log('CHECKING LOGGED IN STATUS');

    if (boolToken === null || boolToken === undefined) {
        return false;
    } else {
        return true;
    }
};

// Ensures that user is logged in before accessing route.
// Will redirect user to login page if not logged in
const PrivateRoute = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) =>
                loggedIn() ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: { from: props.location },
                        }}
                    />
                )
            }
        />
    );
};

PrivateRoute.propTypes = {
    component: PropTypes.object.isRequired,
    location: PropTypes.object,
};

const LoginRoute = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) =>
                props.location.pathname.includes('download_pdf') ? (
                    <Component {...props} />
                ) : loggedIn() ? (
                    <Redirect
                        to={{
                            pathname: '/dashboard',
                            state: { from: props.location },
                        }}
                    />
                ) : (
                    <Component {...props} />
                )
            }
        />
    );
};

LoginRoute.propTypes = {
    component: PropTypes.object.isRequired,
    location: PropTypes.object,
};

const ExemptRoute = ({ component: Component, ...rest }) => {
    return <Route {...rest} render={(props) => <Component {...props} />} />;
};

ExemptRoute.propTypes = {
    component: PropTypes.object.isRequired,
    location: PropTypes.object,
};

const ComponentRoutes = () => {
    return (
        <React.Fragment>
            {/* <NotificationContainer /> */}
            <ToastContainer
                closeButton={false}
                newestOnTop={true}
                toastClassName={'portal-toast'}
                bodyClassName={'portal-toast-body'}
            />
            <BrowserRouter>
                <ErrorBoundary>
                    <React.Suspense fallback={loading()}>
                        <Switch>
                            <LoginRoute
                                exact
                                path="/services/:id/:company_id/report/download_pdf"
                                name="download_pdf"
                                component={PDF}
                            />
                            <LoginRoute
                                exact
                                path="/healthcheck/:id/:company_id/report/download_pdf"
                                name="download_pdf"
                                component={PDFHealthCheckReport}
                            />
                            <LoginRoute
                                exact
                                path="/ccpa/:id/:company_id/report/download_pdf"
                                name="download_pdf"
                                component={PDFCCPAReport}
                            />
                            <LoginRoute
                                exact
                                path="/login"
                                name="Login"
                                component={Login}
                            />
                            <LoginRoute
                                exact
                                path="/chat"
                                name="Chat"
                                component={Chat}
                            />
                            <LoginRoute
                                exact
                                path="/signup"
                                name="Sign Up"
                                component={Registration}
                            />
                            <LoginRoute
                                exact
                                path="/confirmation/:token"
                                name="Confirmation"
                                component={confirmationPage}
                            />
                            <LoginRoute
                                exact
                                path="/forgot_password"
                                name="Forgot Password"
                                component={forgotPasswordPage}
                            />
                            <ExemptRoute
                                exact
                                path="/unlock"
                                name="Unlock Account"
                                component={UnlockAccountPage}
                            />
                            <LoginRoute
                                exact
                                path="/password/edit/:token"
                                name="Reset Password"
                                component={resetPasswordPage}
                            />
                            <LoginRoute
                                exact
                                path="/email_confirmation"
                                name="Registration Confirmation"
                                component={SignupConfirmation}
                            />
                            <PrivateRoute
                                path="/"
                                name="MainLayout"
                                component={MainLayout}
                            />
                        </Switch>
                    </React.Suspense>
                </ErrorBoundary>
            </BrowserRouter>
        </React.Fragment>
    );
};

// Used for getting the navigation path
history.listen((location) => {
    // console.log('history - ', location);
    // pagePath =
    //     window.location.hash != ''
    //         ? window.location.hash
    //         : window.location.pathname + window.location.search;
    // ReactGA.pageview(pagePath)
});

class App extends React.Component {
    render() {
        return isMobileOnly ? (
            <Mobile />
        ) : (
            <ErrorBoundary>
                <Provider store={store} history={history}>
                    <CacheBuster>
                        {({
                            loading,
                            isLatestVersion,
                            refreshCacheAndReload,
                        }) => {
                            if (loading) return null;
                            if (!loading && !isLatestVersion) {
                                // You can decide how and when you want to force reload
                                refreshCacheAndReload();
                            }

                            return <ComponentRoutes />;
                        }}
                    </CacheBuster>
                </Provider>
            </ErrorBoundary>
        );
    }
}

// ReactDOM.render(
//    <Provider store={store} history={history}>
//                 <ComponentRoutes />
//             </Provider>,
//     document.getElementById('root')
// );
ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js